import request from "@/api/request";

// 首页轮播图
export const homeSwiperRequest = (() => {
  return request.get('/paperShow/findCarousel')
})
// 公告
export const gonggaoRequset = ((params) => {
  return request.get('/paperShow/findInformationAffiche',params)
})
// 资讯
export const zixunRequset = ((params) => {
  return request.get('/paperShow/findInformationMmssage',params)
})
// 推荐展览
export const findExhibitionRequest = (() => {
  return request.get('/paperShow/findExhibition')
})
// 推荐藏品
export const findCollectionRequest = ((params) => {
  return request.get('/paperShow/findCollection',params)
})
// 浏览量
export const getAmountRequest = (() => {
  return request.get('/paperBrowse/getAmount')
})
// 调查问卷
export const getQuestionnaireReq = (() => {
  return request.get('/paperShow/getQuestionnaire')
})
